import $ from 'jquery';
import Cookie from '@shopify/marketing-assets/javascripts/helpers/cookie-helper';

export default function initializeShopifyYCookie() {
  $('.js-shopify-y-cookie').val(Cookie.get('_shopify_y'));
  $("[name='subscriber_param_shopify_y']").val(Cookie.get('_shopify_y'));
}
